export class FilterModel {
    filterName: string;
    filter: string;

    constructor(_filterName: string, _filter: string) {
        this.filterName = _filterName;
        this.filter = _filter;
    }
}